<template>
  <div class="menu-container">
    <!-- 分类菜单 -->
    <div class="menu">
      <div
        v-for="(category, index) in categoriesList"
        :key="index"
        class="menu-item"
        :class="{ active: activeCategory === category }"
        @click="selectCategory(category)"
      >
        {{ category }}
      </div>
    </div>

    <!-- 显示选中分类下的商品 -->
    <div class="content">
      <div v-if="activeCategory">
       
        <div v-for="(item, index) in categories[activeCategory]" :key="index" class="product">
          <img :src="item.image" alt="商品图片" class="product-img" />
          <div class="product-info">
            <p>{{ item.name }}</p>
            <p>{{ item.price }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 分类和对应商品信息
      categories: {
        "P系列": [
          { name: "商品1", price: "¥939", image: "image1.png" },
          { name: "商品2", price: "¥1234", image: "image2.png" }
        ],
        "U系列": [
          { name: "商品3", price: "¥200", image: "image3.png" },
          { name: "商品4", price: "¥150", image: "image4.png" }
        ],
        "K系列": [
          { name: "商品5", price: "¥500", image: "image5.png" },
          { name: "商品6", price: "¥800", image: "image6.png" }
        ]
      },
      // 当前选中的分类
      activeCategory: "P系列",
    };
  },
  computed: {
    // 获取所有的分类名（即对象的键）
    categoriesList() {
      return Object.keys(this.categories);
    }
  },
  methods: {
    // 选择分类时更新显示内容
    selectCategory(category) {
      this.activeCategory = category;
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.menu-container {
  display: flex;
}

.menu {
  display: flex;
  flex-direction: column;
  background: #f0f0f0;
  width: 200px;
  padding: 10px;
}

.menu-item {
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  text-align: left;
  border-radius: 5px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.menu-item:hover {
  background-color: #ddd;
}

.menu-item.active {
  background-color: #00f;
  color: white;
}

.content {
  margin-left: 220px;
  padding: 20px;
  background-color: #fff;
  flex: 1;
}

.product {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.product-img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin-right: 10px;
}

.product-info {
  display: flex;
  flex-direction: column;
}
</style>
